<template>
    <div>
            <b-row>
                <b-col cols="12">
                    <b-form-group :label="$t('name')">
                        <b-input-group :prepend="$t('variable_language')">
                            <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                        </b-input-group>
                        <b-input-group prepend="EN">
                            <div class="label-as-input">{{ isNotNullValue(form.name_en) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                        <b-form-group :label="$t('code')">
                            <b-form-input v-model="form.code"
                                                    :disabled="true" />
                        </b-form-group>
                </b-col>
                <b-col cols="12">
                        <b-form-group :label="$t('start_date')">
                            <b-form-input v-model="form.start_date"
                                         :disabled="true"
                                         :is-time="true" />
                        </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('end_date')">
                        <b-form-input v-model="form.end_date"
                                     :disabled="true"
                                     :is-time="true" />
                    </b-form-group>
                </b-col>
            </b-row>
    </div>
</template>

<script>
    //Service
    import TicketEventService from "@/services/TicketEventService";

    export default {
        components: {},
        data() {
            return {
                formLoading: false,
                form: {
                    name: null,
                    name_en: null,
                    code: null,
                    start_date: null,
                    end_date: null,
                }
            }
        },
        props: {
            formId: {
                type: Number,
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                TicketEventService.get(id)
                              .then((response) => {
                                  this.form = response.data.data;
                              })
                              .catch((error) => {
                                  this.showErrors(error)
                              })
            }
        }
    }
</script>
